import type { Choice, Trial } from '../lib/types';

function delayText(days: number) {
  if (days === 1) return 'tomorrow';
  if (days < 30) return `in ${days} days`;
  if (days < 365) return `in about ${Math.round(days / 30)} months`;
  return 'in one year';
}

export function ChoiceArena({
  trial,
  progress,
  total,
  onAnswer
}: {
  trial: Trial;
  progress: number;
  total: number;
  onAnswer: (choice: Choice) => void;
}) {
  return (
    <section className="panel arena-panel" aria-labelledby="arena-title">
      <div className="panel-header">
        <div>
          <p className="eyebrow">round {progress + 1} / {total}</p>
          <h2 id="arena-title">Choose the world you actually feel</h2>
        </div>
        <div className="prompt-chip">{trial.promptTheme}</div>
      </div>

      <div className="progress-track" aria-hidden="true">
        <span style={{ width: `${((progress + 1) / total) * 100}%` }} />
      </div>

      <p className="arena-copy">
        No moralizing, no “correct” answer. The curve learns from the tiny weather of your choices.
      </p>

      <div className="choice-grid">
        <button className="choice-card sooner" onClick={() => onAnswer('sooner')}>
          <span className="choice-kicker">spark now</span>
          <strong>{trial.soonerAmount} coins</strong>
          <span>available today</span>
        </button>
        <div className="versus" aria-hidden="true">or</div>
        <button className="choice-card later" onClick={() => onAnswer('later')}>
          <span className="choice-kicker">vault later</span>
          <strong>{trial.laterAmount} coins</strong>
          <span>{delayText(trial.delayDays)}</span>
        </button>
      </div>

      <div className="trial-math">
        <span>Current probe: value of 100 delayed coins at {trial.delayDays} day{trial.delayDays === 1 ? '' : 's'}</span>
        <span>Bracket: {Math.round(trial.low)}–{Math.round(trial.high)}</span>
      </div>
    </section>
  );
}
